/* import __COLOCATED_TEMPLATE__ from './sq-input-fractional-quantity.hbs.js'; */
/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import { isNone } from '@ember/utils';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import SqInputFormattedComponent from '@dashboard/shared-ui/components/sq-input-formatted';
export default SqInputFormattedComponent.extend({
  formatter: service(),
  // passed in
  maxIntegerLength: null,
  minimumFractionDigits: null,
  maximumFractionDigits: 5,
  isInvalid: false,
  didUpdateAttrs() {
    this._super();
    this.field.setFormatter(this._getFormatter());
  },
  _isInvalid: '',
  _internalIsInvalid: computed('invalidClass', 'isInvalid', function () {
    if (this.isInvalid) {
      return this.invalidClass;
    }
    return undefined;
  }),
  _getFormatter() {
    let fractionNumberFormatter = this.formatter.buildFractionNumberFormatter();
    if (!isNone(this.maxIntegerLength)) {
      fractionNumberFormatter = fractionNumberFormatter.setMaximumIntegerDigits(Number.parseInt(this.maxIntegerLength, 10));
    }
    if (!isNone(this.minimumFractionDigits)) {
      fractionNumberFormatter = fractionNumberFormatter.setMinimumFractionDigits(Number.parseInt(this.minimumFractionDigits, 10));
    }
    fractionNumberFormatter = fractionNumberFormatter.setMaximumFractionDigits(Number.parseInt(this.maximumFractionDigits, 10));
    return fractionNumberFormatter;
  }
});